module.exports = __webpack_public_path__ + "static/img/014酒庄官网5.6109f3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/014酒庄官网5.jpg
// module id = ojKI
// module chunks = 0